import { render, staticRenderFns } from "./StakeDia.vue?vue&type=template&id=4f2744cb&scoped=true"
import script from "./StakeDia.vue?vue&type=script&lang=js"
export * from "./StakeDia.vue?vue&type=script&lang=js"
import style0 from "./StakeDia.vue?vue&type=style&index=0&id=4f2744cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2744cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2744cb')) {
      api.createRecord('4f2744cb', component.options)
    } else {
      api.reload('4f2744cb', component.options)
    }
    module.hot.accept("./StakeDia.vue?vue&type=template&id=4f2744cb&scoped=true", function () {
      api.rerender('4f2744cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stake/activeValidators/StakeDia.vue"
export default component.exports